import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const NEW_VERSION_QUESTIONNAIRE_SUBSCRIPTION = gql`
  subscription newVersionQuestionnaireUpdated {
    newVersionQuestionnaireUpdated {
      questionnaireId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
export const DUPLICATE_QUESTIONNAIRE_SUBSCRIPTION = gql`
  subscription duplicateQuestionnaireUpdated {
    duplicateQuestionnaireUpdated {
      questionnaireId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
export const QUESTIONNAIRE_DELETE_SUBSCRIPTION = gql`
  subscription questionnaireDeleted {
    questionnaireDeleted {
      questionnaireId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const QUESTIONNAIRE_SAVE_SUBSCRIPTION = gql`
  subscription questionnaireUpdated {
    questionnaireUpdated {
      questionnaire {
        questionnaireId
        isSaved
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
export const QUESTION_DELETE_SUBSCRIPTION = gql`
  subscription questionDeleted {
    questionDeleted
  }
`;
export const QUESTIONACTION_DELETE_SUBSCRIPTION = gql`
  subscription questionActionDeleted {
    questionActionDeleted
  }
`;
